import { ColorEnum } from '@/constants/color'
import Button from '@/features/ui/buttons/components/Button'
import Modal from '@/features/ui/components/Modal'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface ChangeLicenceModalProps {
    licenceName: string
    onConfirm: () => void
    onClose: () => void
}

const ChangeLicenceModal: FC<ChangeLicenceModalProps> = ({ licenceName, onConfirm, onClose }) => {
    const { t } = useTranslation()

    return (
        <Modal contentStyle={styles.modalContent}>
            <Typography.Heading variant="h3" style={styles.title}>
                {t('auth.changeLicenceModal.title')}
            </Typography.Heading>
            <Typography.Description size="large" style={styles.description}>
                {t('auth.changeLicenceModal.descriptionPrefix')}{' '}
                <Typography.Description size="large" font="bold" style={styles.descriptionText}>
                    {licenceName}
                </Typography.Description>
            </Typography.Description>
            <View style={styles.actions}>
                <Button color="secondary" onPress={onConfirm} style={styles.button}>
                    {t('actions.yes').toUpperCase()}
                </Button>
                <Button type="outline" color="secondary" onPress={onClose} style={styles.button}>
                    {t('actions.no').toUpperCase()}
                </Button>
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    modalContent: {
        paddingVertical: 24,
        paddingHorizontal: 16,
    },
    title: {
        color: ColorEnum.Jet700,
        textAlign: 'center',
    },
    description: {
        marginTop: 16,
        textAlign: 'center',
    },
    descriptionText: {
        color: ColorEnum.GRAY_600,
        textAlign: 'center',
    },
    actions: {
        marginTop: 32,
        gap: 16,
    },
    button: {
        width: '100%',
        justifyContent: 'center',
        borderRadius: 8,
    },
})

export default ChangeLicenceModal
